"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKELink = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = require("styled-components");
var DisplayIcon_1 = require("../../../utils/comps/DisplayIcon");
var injectHttps_1 = require("../../../utils/injectHttps");
var utilsOolib_1 = require("../../../utilsOolib");
var styled_1 = require("./styled");
var ProfileImageInput_1 = require("../../../components/ImageInput/derivedComps/ProfileImageInput");
var Typo2_1 = require("../Typo2");
/**
 * @component Renders a link component with customizable text, styling, and behavior.
 *
 * - The component props object containing the following properties:
 * @prop {string} [to]: The URL to link to.
 * @prop {string} [link]: An external URL to link to.
 * @prop {(e: React.MouseEvent<HTMLSpanElement | HTMLAnchorElement>) => void} [onClick]: A callback function to execute when the link is clicked.
 * @prop {keyof typeof icons} [icon]: An icon to display before the text.
 * @prop {DisplayIconProps['weight']} [iconWeight]: The weight of the icon font. Defaults to "regular".
 * @prop {keyof typeof icons} [iconAfter]: An icon to display after the text.
 * @prop {string} [text]: The text to display in the link.
 * @prop {React.ReactNode} [children]: The content to be rendered inside the link.
 * @prop {boolean} [invertUnderline]: A boolean indicating whether to invert the underline style of the link. Defaults to false.
 * @prop {string} [color]: A string indicating the color of the link. Defaults to the primary color of the theme.
 * @prop {boolean} [invert]: A boolean indicating whether to invert the colors of the link. Defaults to false.
 * @prop {boolean} [disabled]: A boolean indicating whether the link is disabled. Defaults to false.
 * @prop {string} [className]: A string indicating the CSS class name to apply to the link.
 * @prop {React.CSSProperties} [style]: Additional CSS styles to apply to the link.
 * @prop {ProfileImageInputProps['value']} [avatar]: An avatar to display in the link.
 * @return {ReactElement} The rendered link component.
 */
var OKELink = function (_a) {
    var _to = _a.to, link = _a.link, onClick = _a.onClick, icon = _a.icon, iconWeight = _a.iconWeight, iconAfter = _a.iconAfter, text = _a.text, children = _a.children, invertUnderline = _a.invertUnderline, color = _a.color, invert = _a.invert, disabled = _a.disabled, className = _a.className, style = _a.style, avatar = _a.avatar;
    var to = link || _to;
    var theme = (0, styled_components_1.useTheme)();
    var localize = (0, utilsOolib_1.useLocale)();
    var getLinkType = function (_a) {
        var to = _a.to, onClick = _a.onClick;
        if (onClick)
            return 'action';
        if (!to)
            return 'external';
        if (typeof to === 'object' && 'pathname' in to)
            return 'internal';
        if (typeof to === 'function')
            return 'internal';
        if (typeof to === 'string')
            return to.substring(0, 1) === '/' ? 'internal' : 'external';
        return 'external';
    };
    var linkType = getLinkType({ to: to, onClick: onClick });
    var textComp = (react_1.default.createElement(styled_1.StyledLinkText, { id: "StyledLinkText" }, localize(children || text)));
    var genIcon = function (icon, position) {
        return (react_1.default.createElement(DisplayIcon_1.DisplayIcon, { icon: icon, weight: iconWeight || 'regular', size: 15, color: (0, styled_1.genColor)({ color: color, theme: theme, invert: invert, disabled: disabled }) }));
    };
    var genAvatar = function (avatar) {
        if (!avatar)
            return;
        return (react_1.default.createElement("div", { style: { marginRight: '1rem', flex: '0 0 auto' } },
            " ",
            react_1.default.createElement(ProfileImageInput_1.ProfileImageInput, { readOnly: true, value: avatar === null || avatar === void 0 ? void 0 : avatar.userUploaded, imageTitle: children || text, size: 20, invert: invert })));
    };
    var linkContents = (react_1.default.createElement(react_1.Fragment, null,
        genAvatar(avatar),
        icon && genIcon(icon, 'before'),
        textComp,
        iconAfter && genIcon(iconAfter, 'after')));
    var commonProps = { color: color, invert: invert, disabled: disabled, className: className || '', invertUnderline: invertUnderline, style: style };
    var genLink = function () {
        switch (linkType) {
            case 'external':
                return (react_1.default.createElement(styled_1.StyledLink, __assign({ as: 'a', href: !disabled ? (0, injectHttps_1.injectHttps)(to) : undefined, target: "_blank", onClick: function (e) {
                        e.stopPropagation();
                    } }, commonProps),
                    react_1.default.createElement(Typo2_1.UI_CAPTION, null, linkContents)));
            case 'action':
                return (react_1.default.createElement(styled_1.StyledLink, __assign({ as: 'span', onClick: function (e) {
                        e.stopPropagation();
                        !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
                    } }, commonProps),
                    react_1.default.createElement(Typo2_1.UI_CAPTION, null, linkContents)));
            case 'internal':
            default:
                return (react_1.default.createElement(styled_1.StyledLink, __assign({ as: react_router_dom_1.Link, to: !disabled ? to : undefined, onClick: function (e) {
                        e.stopPropagation();
                    } }, commonProps),
                    react_1.default.createElement(Typo2_1.UI_CAPTION, null, linkContents)));
        }
    };
    return react_1.default.createElement(react_1.Fragment, null, genLink());
};
exports.OKELink = OKELink;
